<div class="modal-body">
  <h2 class="payment-cash-info">{{ title | translate }}</h2>
  <div class="money" *ngIf="acceptedBills && acceptedBills.length > 0">
    <accepted-cash [text]="'Banknotes'" [acceptedCash]="acceptedBills" [cashType]="cashTypeBanknote"></accepted-cash>
  </div>
  <div class="money" *ngIf="acceptedCoins && acceptedCoins.length > 0">
    <accepted-cash [text]="'Coins'" [acceptedCash]="acceptedCoins" [cashType]="cashTypeCoin"></accepted-cash>
  </div>
</div>
